import { render, staticRenderFns } from "./claimForm.vue?vue&type=template&id=35d58782&scoped=true"
import script from "./claimForm.vue?vue&type=script&lang=js"
export * from "./claimForm.vue?vue&type=script&lang=js"
import style0 from "./claimForm.vue?vue&type=style&index=0&id=35d58782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d58782",
  null
  
)

export default component.exports